// @flow

export type vector = [number, number]

export const Vector2D = {
  rotate([x, y]: vector, angle: number): vector {
    const cos = Math.cos(angle)
    const sin = Math.sin(angle)
    return [Math.round(x * cos - y * sin), Math.round(x * sin + y * cos)]
  },

  add([x, y]: vector, [dx, dy]: vector): vector {
    return [x + dx, y + dy]
  },

  scale([x, y]: vector, scale: number): vector {
    return [x * scale, y * scale]
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/mandat-svg/Vector2D/vector2d.js